module.exports = __webpack_public_path__ + "static/media/balance.cbf2099b.svg";